<template>
	<div class='home'>
        <div class='homecontent'>
			<img class='logo' src="resources/logo.png" >
			<videoplayer />
			<div class="description">
				<p>Nextslideplease was created by the BR.Monks to help you with the difficult task of screen sharing a deck during a virtual call where there are multiple presenters. Now you don't have to ask your colleague to
                <span class='citation' style="display:inline">"go to the next slide please"</span> - you just control it!</p>
			</div>

			<div class="buttons">
				<div class='vmin'>
					<p v-if='version'>Current Version v{{version}}</p>
				</div>
				<button @click='downloadMac'>MAC DOWNLOAD
                    
                </button>
				<div class='v'>
					<p v-if='version'>v{{version}}</p>
				</div>
				<button @click='downloadPC'>PC DOWNLOAD</button>
			</div>
            <p class="mac-psa">* Using MAC? Make sure to check <a href="https://support.apple.com/en-us/HT202491" target="_blank">security & privacy</a> options.</p>
			<div class="mediamonkscopy">© Copyright {{getYear}} Media.Monks</div>
			<div id="btngoogleauth" ref='btngoogle'></div> <!-- DO NOT REMOVE THAT DIV -->
		</div>
	</div>
</template>

<script>

import videoplayer from '../components/videoplayer.vue'
import googleauth from '../components/googleauth.vue'

export default {

	components: {
		videoplayer, googleauth
	},

	data: () => ({
		version: null,
		loggedIn: false
	}),

	mounted() {
		this.init()
	},

	watch: {
		loggedIn()
		{
			this.$refs.btngoogle.style.display = this.loggedIn ? 'none' : 'block'
		}
	},

    computed: {
        getYear() {
            return new Date().getFullYear();
        }
    },

	methods: {

		downloadMac()
		{
			window.open(`data/bin/Nextslideplease-${this.version}.dmg`, '_blank')
		},

		downloadPC()
		{
			window.open(`data/bin/Nextslideplease-${this.version}.exe`, '_blank')
		},

		async init()
		{
			let data = await this.getVersion()
			this.version = data.v
		},

		async getVersion()
		{
			return new Promise((resolve, reject) => {

				let http = new XMLHttpRequest();
				const url = "version.json?r=" + Math.floor(Math.random() * 999999);
				http.open("GET", url);
				http.send();

				http.onreadystatechange = (e) => {
					if (http.readyState === 4)
					{
						if (http.status === 200)
						{
							let json = null
							try { json = JSON.parse(http.responseText) } catch {}
							resolve(json)
						}
						else
						{
							reject(http.statusText)
						}
					}
				}
			})
		}
	}
}
</script>

<style lang="scss" scoped>

	.home {
		margin-bottom: 16px;
	}



	.homecontent {
		opacity: 1;
		transition: opacity 1s linear;
	}



	.description {
		position: relative;
		text-align: center;
		margin-top: 32px;
		margin-bottom: 50px;


		p {
			line-height: 1.8;
			font-size: 16px;
			margin: 0;
		}

		.citation {
			font-style: italic;
			color: #ccc;
		}
	}

	.buttons {
		position: relative;
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: space-between;
		max-width: calc(100% - 50px);
		width: 480px;
		left: 50%;
		transform: translateX(-50%);
		margin-bottom: 16px;

		p { color: #ffbd69; }

		button {
			width: 172px;
			margin: 0;
			padding: 0;
		}

		.vmin {
			display: none;
		}

		.v {
			display: block;
		}
	}

    .mac-psa {
        color: #888;
        font-size: 12px;
        text-align: center;
        margin-bottom: 16px;
    }

	.mediamonkscopy {
		text-align: right;
		font-size: 11px;
		color: #888;
	}

	.logo {
		position: relative;
		width: 90%;
		max-width: 320px;
		margin-top: 50px;
		margin-bottom: 50px;
	}


	.authbox {
		position: relative;

		.logo {
			max-width: 420px;
			position: relative;
			left: 50%;
			transform: translateX(-50%);
		}

		#btngoogleauth {
			position: relative;
			left: calc(50% - 120px);
		}
	}

	@media screen and (max-width: 720px) {
		.description {
			margin-left: 0;
			margin-right: 0;

			p {
				line-height: 1.8;
				font-size: 14px;
			}
		}

        .mac-psa {
            font-size: 10px;
        }
	}

	@media screen and (max-width: 640px) {

		.home {
			margin-bottom: 8px;
		}

		.logo {
			margin-top: 10vw;
			margin-bottom: 8vw;
		}

		.description {
			margin-left: 0;
			margin-right: 0;
			margin-bottom: 12px;

			p {
				line-height: 1.5;
				font-size: 3.6vw;
			}
		}

		.buttons {
			flex-direction: column;

			button {
				margin-top: 8px;
				margin-bottom: 12px;
			}

			.vmin {
				display: block;
				p { font-size: 11px;}
			}

			.v {
				display: none;
			}
		}

        .mac-psa {
            font-size: 2vw;
        }
	}

	@media screen and (max-width: 320px) {
		.buttons {

			.vmin {
				p { font-size: 10px;}
			}

			button {
				margin-top: 4px;
				margin-bottom: 8px;
				height: 32px;
			}

		}
	}

</style>
